import { type ApiEvidenceV1EvidenceTypesRetrieve200ResultsItem, useApiEvidenceV1EvidenceTypesRetrieve } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<ApiEvidenceV1EvidenceTypesRetrieve200ResultsItem>, 'options'>;

export const EvidenceTypeSelector = ({ ...rest }: Props) => {
  const { data, isLoading } = useApiEvidenceV1EvidenceTypesRetrieve();

  return (
    <AutocompleteField<ApiEvidenceV1EvidenceTypesRetrieve200ResultsItem>
      data-testid="evidence-type-selector"
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(option) => option.label}
      valueField="value"
      {...rest}
    />
  );
};
